module.exports = require("vscode-nls");